import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const createBalanceTransactionExport = {
  name: "createBalanceTransactionExport" as const,
  input: z.object({
    filters: z.array(AdvancedFilterDataSchema),
    sendToEmail: z.string().email().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
